import * as types from "../types/warningPopup"

const initialState = {
  show: false,
  message: ""
}

const warningPopupReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_WARNING_POPUP:
      return {
        show: true,
        message: action.message
      }
    case types.HIDE_WARNING_POPUP:
      return {
        ...state,
        show: false
      }
    default:
      return state
  }
}

export default warningPopupReducer